import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ClaimTypes} from "../../../model/claim-type.model";
import {TransactionInfoService} from "../../../services/transaction-info.service";

@Component({
    selector: 'app-stay-in-hospital',
    templateUrl: './stay-in-hospital.component.html',
    styleUrls: ['./stay-in-hospital.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StayInHospitalComponent implements OnInit {

    constructor( private transactionInfoService: TransactionInfoService) {
        this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_MED_STY]);
    }

  ngOnInit() {
  }

}
